import React, { useEffect } from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { ReclamosContent } from './components/ReclamosContent';
import { useNavigate, useParams } from 'react-router-dom';

export default function Reclamos() {
    const navigate = useNavigate();
    const { tipoGestion } = useParams();

    useEffect(() => {
        if (!tipoGestion || (tipoGestion !== 'efi' && tipoGestion !== 'reclamos')) { //Valido que la URL sea correcta
            navigate('/menu', { replace: true });
        }
    }, [tipoGestion]);
    
    return (
        <>
            <MainContent
                component={<ReclamosContent />}
                titulo={`Gestión de ${tipoGestion === 'efi' ? 'EFI' : 'Reclamos'}`}
                noBackground
                tableMaxWidth
            />
        </>
    );
};
